<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>

    <div *ngIf="data.confirmText === 'Approve'" mat-dialog-content class="dialog-content text-muted">
        {{ isLoading ? 'Processing, please wait...' : data.content }}
    </div>

    <div *ngIf="data.confirmText === 'Reject'" mat-dialog-content class="dialog-content text-muted">
        <mat-form-field appearance="outline" class="w-100 mt-3">
            <mat-label>Reason</mat-label>
            <textarea matInput [(ngModel)]="userInput" #reasonInput="ngModel" rows="3"
                placeholder="Enter your reason here" name="reason" required [disabled]="isLoading">
            </textarea>
            <mat-error *ngIf="reasonInput.invalid && reasonInput.touched">
                Reason is required
            </mat-error>
        </mat-form-field>
    </div>

    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()" [disabled]="isLoading">
            {{ data.cancelText }}
        </button>

        <button *ngIf="data.confirmText === 'Approve'" mat-button class="approve-button"
            (click)="approveLeave(data.id)" [disabled]="isLoading" cdkFocusInitial>
            <span *ngIf="!isLoading">{{ data.confirmText }}</span>
            <span *ngIf="isLoading">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Retrying...
            </span>
        </button>

        <button *ngIf="data.confirmText === 'Reject'" mat-button class="delete-button"
            (click)="declineLeave(data.id, userInput)" [disabled]="!userInput?.trim() || isLoading" cdkFocusInitial>
            <span *ngIf="!isLoading">{{ data.confirmText }}</span>
            <span *ngIf="isLoading">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Retrying...
            </span>
        </button>
    </div>
</div>
